import { toast } from "react-toastify";
import { calculateAndFormatNoAbsInt } from "../../../component/Methods";

export function getCrossingTradesExportHeaders(tableHeader = []) {
  return tableHeader.filter((col) => col.id !== "ignore" && !col.isCheckbox);
}

export function formatCrossingTradeExportCell(columnId, row) {
  if (columnId === "shareCount") {
    const shareCount = row?.shareCount;
    if (shareCount === undefined || shareCount === null) return "";
    if (shareCount < 0) return `(${Math.abs(shareCount)})`;
    return `${calculateAndFormatNoAbsInt(shareCount)}`;
  }

  if (columnId === "ticker") {
    return (row?.ticker || "").toUpperCase();
  }

  const value = row?.[columnId];
  return value === undefined || value === null ? "" : String(value);
}

function escapeTsvCell(value) {
  const str = value === undefined || value === null ? "" : String(value);
  const sanitized = str.replace(/\r?\n/g, " ");
  if (/[\t"]/.test(sanitized)) {
    return `"${sanitized.replace(/"/g, '""')}"`;
  }
  return sanitized;
}

function buildCrossingTradesTsvContent(rows, tableHeader, { includeSepLine = false } = {}) {
  const headers = getCrossingTradesExportHeaders(tableHeader);
  if (!headers.length) return "";

  const headerLine = headers.map((col) => escapeTsvCell(col.label)).join("\t");
  const dataLines = (rows ?? []).map((row) =>
    headers
      .map((col) => escapeTsvCell(formatCrossingTradeExportCell(col.id, row)))
      .join("\t")
  );

  const lines = includeSepLine
    ? ["sep=\t", headerLine, ...dataLines]
    : [headerLine, ...dataLines];

  return lines.join("\n");
}

export function buildCrossingTradesTsv(rows, tableHeader) {
  return buildCrossingTradesTsvContent(rows, tableHeader);
}

export function getCrossingTradesExportFileName() {
  const date = new Date();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = String(date.getFullYear()).slice(-2);
  return `crossing_trades_${month}-${day}-${year}.xls`;
}

export async function copyCrossingTradesForExcel(rows, tableHeader) {
  if (!rows?.length) {
    toast.error("No crossing trades to copy");
    return;
  }

  const tsv = buildCrossingTradesTsv(rows, tableHeader);

  try {
    await navigator.clipboard.writeText(tsv);
    toast.success("Crossing trades copied for Excel");
  } catch (error) {
    console.error("Failed to copy crossing trades:", error);
    toast.error("Failed to copy to clipboard");
  }
}

export function downloadCrossingTradesAsExcel(rows, tableHeader) {
  if (!rows?.length) {
    toast.error("No crossing trades to download");
    return;
  }

  const tsv = buildCrossingTradesTsvContent(rows, tableHeader, {
    includeSepLine: true,
  });
  const blob = new Blob(["\uFEFF", tsv], {
    type: "application/vnd.ms-excel;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = getCrossingTradesExportFileName();
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  toast.success("Crossing trades downloaded");
}
